import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Form from 'flarum/common/components/Form';
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
export default class ResultsModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "userRequestAttr", void 0);
    _defineProperty(this, "user", void 0);
    _defineProperty(this, "request", void 0);
    _defineProperty(this, "translationPrefix", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.userRequestAttr = "last".concat(this.attrs.nickname ? 'Nickname' : 'Username', "Request");
    const user = app.session.user;
    if (user) {
      this.user = user;
      this.request = this.user[this.userRequestAttr]();
    }
    this.translationPrefix = "fof-username-request.forum.".concat(this.request.forNickname() ? 'nickname' : 'username', "_modals.results");
  }
  className() {
    return 'ResultsModal Modal';
  }
  title() {
    return app.translator.trans("".concat(this.translationPrefix, ".title"));
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m(Form, {
      className: "Form--centered"
    }, this.request.status() === 'Approved' ? [m("h2", null, app.translator.trans("".concat(this.translationPrefix, ".approved"))), m("h3", null, app.translator.trans("".concat(this.translationPrefix, ".new_name"), {
      name: this.user.displayName()
    }))] : [m("h2", null, app.translator.trans("".concat(this.translationPrefix, ".rejected"))), m("h3", null, app.translator.trans("".concat(this.translationPrefix, ".reason"), {
      reason: this.request.reason(),
      i: m("i", null)
    })), m("p", {
      className: "helpText"
    }, app.translator.trans("".concat(this.translationPrefix, ".resubmit")))], m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      onclick: this.hide.bind(this)
    }, app.translator.trans("".concat(this.translationPrefix, ".dismiss_button"))))));
  }
  onremove() {
    this.user[this.userRequestAttr] = Stream();
    this.request.delete();
  }
}
flarum.reg.add('fof-username-request', 'forum/components/ResultsModal', ResultsModal);